// Catálogo estático de Perfiles: solo 2 valores fijos (Administrador/Cliente)
// que no cambian; no amerita un endpoint propio.
export const PERFILES = [
  { perfilId: 1, nombre: "Administrador" },
  { perfilId: 2, nombre: "Cliente" },
];
